<template>
		<div class="header">
				<div class="nav-topbar">
						<div class="container flex-row flex-y-bottom">
								<div class="topbar-logo">
										<router-link to="/index">
												<img :src="imgUrl+setting.logo" alt=""/>
										</router-link>
								</div>
								<div class="flex-row flex-y-bottom" style="margin-bottom: 5px">
										<div class="lianxi flex-row flex-y-center">
												<img :src="imgUrl+setting.hotpic" alt=""/>
										</div>

										<div class="topbar-user flex-row flex-y-center">
												<a href="javascript:;" v-if="!username" @click="login">登录</a>
												<a href="javascript:;" v-if="!username" class="line"></a>
												<a  href="javascript:;" v-if="!username" @click="register">注册</a>
												<a href="javascript:;" v-if="username">{{ username }}</a>
												<a href="javascript:;" v-if="username" class="line"></a>
												<a href="javascript:;" v-if="username" @click="logout">退出</a>
												<a href="javascript:;" v-if="username" class="line"></a>
												<router-link to="/user" v-if="username">我的</router-link>
										</div>
								</div>
						</div>
				</div>
				<div class="nav-header">
						<div class="container flex-row flex-x-center" style="justify-content: center">
								<div class="header-menu flex-row flex-y-center">
										<div class="item-menu " :class="{'active':catId==0}">
												<router-link to="/index">网站首页</router-link>
												<span></span>
												<!--<div class="children">
														<ul>
																<li
																		class="product"
																		v-for="(item, index) in phoneList"
																		:key="index"
																>
																		<a v-bind:href="'/#/product/' + item.id" target="_blank">
																				<div class="pro-img">
																						<img :src="item.mainImage" :alt="item.subtitle"/>
																				</div>
																				<div class="pro-name">{{ item.name }}</div>
																				<div class="pro-price">{{ item.price }}</div>
																		</a>
																</li>
														</ul>
												</div>-->
										</div>
										<div class="item-menu" :class="{'active':catId==item.id || catParentId==item.id}" v-for="(item,index) in  navList" :key="index">
												<router-link :to="item.url">{{item.name}}</router-link>
												<span></span>
										</div>

								</div>
								<!--<div class="header-search">
										<div class="wrapper">
												<input type="text" name="keyword"/>
												<a href="javascript:;"></a>
										</div>
								</div>-->
						</div>
				</div>
		</div>
</template>
<script>
import {getCurrentInstance, computed, onMounted, ref} from "vue";
import Cookies from "js-cookie";
import storage from "@/storage";
import {ElMessage, ElMessageBox} from "element-plus";

export default {
		name: "nav-header",
		setup() {
				const {proxy} = getCurrentInstance();
				const imgUrl=proxy.$imgUrl;
				const isMobile= proxy.$isMobile;
				//let navList = ref([]);

				let store = proxy.$store;
				let username = computed(() => {
						return store.state.username;
				});

				let catId = computed(() => {
						return store.state.catId;
				});
				let catParentId = computed(() => {
						return store.state.catParentId;
				});

				let setting = computed(() => {
						return store.state.setting;
				});
				let navList = computed(() => {
						return store.state.cat_list;
				});
				// 初始化接口
				onMounted(() => {
						//getNavList();
						/*let params = proxy.$router.currentRoute.value.params;*/
				});
				const login = () => {
						proxy.$router.push("/login");
				};
				const register = () => {
						proxy.$router.push("/register");
				};
				const getNavList = () => {
						proxy.$axios.get("/home/getColumnList", {
										params: {},
								})
								.then((res) => {
										console.log("getColumnList",res);
										navList.value = res.data;
										store.commit("saveCatList", res.data);
										/*storage.setItem('catList', res.data);*/
								});
				};
				const logout = () => {
						ElMessageBox.confirm('确定要退出吗?', '提示', {
								confirmButtonText: '确认提交',
								cancelButtonText: '取消',
								type: 'warning',
						}).then(() => {
								Cookies.set("userId", "", {expires: -1});
								Cookies.set("token", "", {expires: -1});
								proxy.$store.dispatch("saveUserName", "");
								ElMessage({
										type:'success',
										message:'退出成功',
										offset:200,
										duration:1500,
										onClose: () => { // 消息关闭时的回调函数
												proxy.$router.push("/index");
										}
								})
						}).catch(() => {

						})
						/*proxy.$axios.post("/user/logout").then(() => {

						});*/
				};
				const goToCart = () => {
						proxy.$router.push("/cart");
				};
				return {
						isMobile,
						username,
						navList,
						catId,
						catParentId,
						setting,
						imgUrl,
						login,
						register,
						getNavList,
						logout,
						goToCart,
				};
		},
		filters: {
				currency(val) {
						if (!val) return "0.00";
						return "￥" + val.toFixed(2) + "元";
				},
		},
};
</script>
<style lang="scss">
@import "./../assets/scss/base.scss";
@import "./../assets/scss/mixin.scss";
@import "./../assets/scss/config.scss";

.header {
		background-color:var(--color-a);
		font-family: "siyuan";
		height: 190px;
		min-width: 1226px;
		.nav-topbar {
				height: 120px;
				color: #b0b0b0;
				padding-top: 20px;
				.container {
						justify-content: space-between;
						.topbar-logo{
								img{
										height: 100px;
								}
						}
						.lianxi{
								img{
										height: 60px;
								}
						}
						.topbar-user{
								margin-bottom: 5px;
								margin-left: 20px;
								a{
										color: var(--color-d);
										font-size: 18px;
										&.line{
												width: 2px;
												height: 15px;
												background: var(--color-d);
												margin: 0 5px;
										}
								}
						}
				}
		}

		.nav-header {
				.container {
						position: relative;
						height: 70px;
						.header-menu {
								width: 1000px;
								@include flex();
								.item-menu {
										display: inline-block;
										font-size: 20px;
										line-height: 70px;
										position: relative;
										a {
												display: inline-block;
												cursor: pointer;
												color: var(--color-d);
												font-weight: bold;
										}
										span{
												display: none;
												position: absolute;
												left:0;
												bottom:0
										}

										&.active,&:hover {
												a{
														font-weight: bold;
												}
												span{
														display: block;
														width: 100%;
														height: 10px;
														background: var(--color-c);
												}
												.children {
														height: 220px;
														opacity: 1;
														border-top: 1px solid #e5e5e5;
												}
										}

										.children {
												position: absolute;
												top: 112px;
												left: 0;
												width: 1226px;
												height: 0;
												opacity: 0;
												overflow: hidden;
												box-shadow: 0px 7px 6px 0px rgba(0, 0, 0, 0.11);
												z-index: 10;
												transition: all 0.5s;
												background-color: #ffffff;

												.product {
														position: relative;
														float: left;
														width: 16.6%;
														height: 220px;
														font-size: 12px;
														line-height: 12px;
														text-align: center;

														a {
																display: inline-block;
														}

														img {
																width: auto;
																height: 111px;
																margin-top: 26px;
														}

														.pro-img {
																height: 137px;
														}

														.pro-name {
																font-weight: bold;
																margin-top: 19px;
																margin-bottom: 8px;
																color: var(--color-b);
														}

														.pro-price {
																/*color: $colorA;*/
																color: var(--color-a);
														}

														&:before {
																content: " ";
																position: absolute;
																top: 28px;
																right: 0;
																border-left: 1px solid var(--color-f);
																height: 100px;
																width: 1px;
														}

														&:last-child:before {
																display: none;
														}
												}
										}
								}
						}

						.header-search {
								width: 319px;

								.wrapper {
										height: 50px;
										border: 1px solid #e0e0e0;
										display: flex;
										align-items: center;
										box-sizing: content-box;

										input {
												border: none;
												box-sizing: border-box;
												border-right: 1px solid #e0e0e0;
												width: 264px;
												height: 50px;
												padding-left: 14px;
										}

										a {
												@include bgImg(18px, 18px, "./../assets/imgs/icon-search.png");
												margin-left: 17px;
										}
								}
						}
				}
		}
}
</style>
